import React, { useEffect, useState } from "react";
import { List, Modal, Popconfirm, Skeleton } from "antd";
import { useLazyGetWorkOrderHistoryQuery } from "../../store/services/api/work-order-api";
import {humanizeDate, humanizeEnum} from "../../utils/humanizers";
import { WorkOrderPriority, WorkOrderType } from "../../store/data/entities/work-order";
import { WorkOrderStatus } from "../../store/data/entities/work-order";
import { Button } from "antd";
import {useNavigation} from "@react-navigation/native";



interface WorkOrderHistoryModalProps {
  workOrderId: string;
  isOpen:boolean
  onClose: () => void;
}

export default function WorkOrderHistoryModal({
  workOrderId,
  isOpen,
  onClose
}: WorkOrderHistoryModalProps) {
  const [getWorkOrderHistory, { data, isFetching }] =
    useLazyGetWorkOrderHistoryQuery();
 const navigation = useNavigation<any>();
  useEffect(() => {
    getWorkOrderHistory({ workOrderId });
  }, [isOpen, workOrderId, getWorkOrderHistory]);

  const hasChanged = (
    current: any,
    previous: any,
    field: keyof typeof current
  ) => {
    if (!previous) return false; 
    return current?.[field] !== previous?.[field];
  };

  const highlightStyle: React.CSSProperties = {
    color: "#cf1322",
    fontWeight: 600,
    borderRadius: 4,
  };

  const renderCell = (
    field: keyof typeof item,
    value: React.ReactNode,
    current: any,
    previous: any
  ) => (
    <div
      style={{
        flex: 2,
        ...(hasChanged(current, previous, field) && highlightStyle),
      }}
    >
      {value}
    </div>
  );

  return (
    <>
      <Modal
        width="100%"
        centered
        title="Previous Updates"
        open={isOpen}
        onCancel={onClose}
        onOk={null}
        footer={null}
      >
        <Skeleton loading={isFetching} active>
          <div
            style={{
              display: "flex",
              fontWeight: 600,
              borderBottom: "1px solid #f0f0f0",
              padding: "8px 16px",
            }}
          >
            <div style={{ flex: 2 }}>Updated By</div>
            <div style={{ flex: 2 }}>Updated By Role</div>
            <div style={{ flex: 2 }}>Last Modified On</div>
            <div style={{ flex: 2 }}>Location Label</div>
            <div style={{ flex: 2 }}>Priority</div>
            <div style={{ flex: 2 }}>Reopened On</div>
            <div style={{ flex: 2 }}>Reopened Reason</div>
            <div style={{ flex: 2 }}>Owner</div>
            <div style={{ flex: 2 }}>Description</div>
            <div style={{ flex: 2 }}>Type</div>
            <div style={{ flex: 2 }}>Status</div>
            <div style={{ flex: 2 }}>Scheduled Start Date</div>
            <div style={{ flex: 2 }}>Scheduled Finish Date</div>
            <div style={{ flex: 2 }}>Technician</div>
            <div style={{ flex: 2 }}>Fault Code</div>
          </div>

          <List
            style={{ maxHeight: "50dvh", overflowY: "auto" }}
            dataSource={data || []}
            renderItem={(item, index) => {
              const comparisonItem =
                index < (data?.length ?? 0) - 1
                  ? data?.[index + 1]
                  : null;

              return (
                <List.Item key={item.id} style={{ padding: "8px 16px" }}>
                  <div style={{ flex: 2 }}>{item.updatedBy}</div>
                  <div style={{ flex: 2 }}>{item.updatedByUserRole}</div>
                  <div style={{ flex: 2 }}>{humanizeDate(item.lastModifiedOn, true)}</div>
                  {renderCell("locationLabel", item.locationLabel, item, comparisonItem)}
                  {renderCell("priority", humanizeEnum(WorkOrderPriority[item.priority]), item, comparisonItem)}
                  {renderCell("reopenedOn", humanizeDate(item.reopenedOn), item, comparisonItem)}
                  {renderCell("reopenedReason", item.reopenedReason, item, comparisonItem)}
                  {renderCell("buildingLead", item.buildingLead, item, comparisonItem)}
                  {renderCell("description", item.description, item, comparisonItem)}
                  {renderCell("type", humanizeEnum(WorkOrderType[item.type]), item, comparisonItem)}
                  {renderCell("status", humanizeEnum(WorkOrderStatus[item.status]), item, comparisonItem)}
                  {renderCell("scheduledStartDate", humanizeDate(item.scheduledStartDate), item, comparisonItem)}
                  {renderCell("scheduledFinishDate", humanizeDate(item.scheduledFinishDate), item, comparisonItem)}
                  {renderCell("technician", item.technician, item, comparisonItem)}
                  {renderCell("fallOutCode", item.fallOutCode, item, comparisonItem)}
                </List.Item>
              );
            }}
          />
        </Skeleton>
      </Modal>
    </>
  );
}
